export default __webpack_public_path__ + "static/feather-callout-bcda997e61fe6c76bffda6084e1802e4.svg";